import * as React from "react";
import { Link } from "react-router-dom";
import type { PracticeSkillLink } from "../lib/practice-types.js";
import "../styles/practice-skill-card.css";

/**
 * A single "practice this skill" card — reused on test-landing pages (topics a
 * test covers) and game detail pages (the topic a game drills). Shows grade
 * level + question count rather than a mastery metric: both surfaces are
 * anonymous, build-time SEO content, not a per-user dashboard, so there's no
 * honest per-visitor progress to report.
 */
export function PracticeSkillCard({ skill }: { skill: PracticeSkillLink }): React.ReactElement {
  return (
    <Link to={`/practice/${skill.gradeSlug}/${skill.slug}`} className="v-skillcard">
      <div className="v-skillcard__head">
        <h3 className="v-skillcard__name">{skill.name}</h3>
        <span className="v-skillcard__go" aria-hidden="true">
          <PlayIcon />
        </span>
      </div>
      <div className="v-skillcard__meta">
        <span className="v-skillcard__grade">{skill.gradeLabel}</span>
        <span className="v-skillcard__count">
          {skill.questionCount} question{skill.questionCount === 1 ? "" : "s"}
        </span>
      </div>
    </Link>
  );
}

function PlayIcon(): React.ReactElement {
  return (
    <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <polygon points="6 4 20 12 6 20" />
    </svg>
  );
}
